import { useSuspenseQuery } from "@tanstack/react-query";
import { Typography } from "antd";
import { Outlet, useLocation } from "react-router-dom";
import { ObjectTabs } from "@/features/object-tabs";
import { routes } from "@/shared/lib/react-router";
import { useObject } from "@entities/object/";
import { projectQueries } from "@entities/project";
import { EntityBaseAbilityBuilder, useUpdateAbility } from "@shared/lib/casl";
import { useCoordinator } from "@shared/lib/hooks";
import { NotFoundFallback, Breadcrumbs } from "@shared/ui";
import { isUnifiedRoute } from "@shared/utils";
import { ProjectObjectsSkeleton } from "./project-objects-skeleton";

const { Title } = Typography;
const generateBreadcrumbs = (projectId: string, projectShortName: string) => {
  return [
    { path: routes.projects(), label: "Проекты" },
    {
      path: routes.project.root({ projectId }),
      label: projectShortName,
    },
    { path: routes.objects.root(projectId), label: "Объекты" },
  ];
};
export const ProjectObjectsView = () => {
  const { objectId, projectId } = useCoordinator();
  const location = useLocation();
  const isUnified = isUnifiedRoute(location.pathname);
  
  const { data: object, isLoading, isError, error } = useObject({ objectId });
  const { data: project } = useSuspenseQuery(
    projectQueries.getProject({
      projectId,
      idType: "projectId",
    }),
  );


  useUpdateAbility({
    permissions: object?.permissions,
    abilityBuilder: EntityBaseAbilityBuilder("object"),
  });

  if (isError) {
    return (
      <NotFoundFallback
        status={(error as Error & { code?: number })?.code ?? 404}
        className="base-error-page-wrapper--content-area"
      />
    );
  }

  if (isLoading) return <ProjectObjectsSkeleton />;
  return (
    <div className="general-view-container">
      <Breadcrumbs
        routes={generateBreadcrumbs(project.projectId, project.shortName)}
        disableFirst={isUnified ? 3 : 0}
      />
      <Title level={3}>{object.shortName}</Title>
      <ObjectTabs />
      <Outlet />
    </div>
  );
};
